import { useEffect, useState } from 'react'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { useTimeZone } from '../../../../hooks'
import { getMockCalendarDayLoad } from '../../CalendarDayLoad.mock'
import {
  getCalendarDayLoadRequestKey,
  getCalendarDayLoadState,
} from '../../CalendarDayLoad.utils'

export function useCalendarRequestsDayLoad({
  date,
  readDayLoad = getMockCalendarDayLoad,
  requestIds,
  ...readParams
}) {
  const timezone = useTimeZone()

  const [response, setResponse] = useState(EMPTY_OBJECT)

  const requestKey = getCalendarDayLoadRequestKey({ date, requestIds })

  async function readLoad(signal) {
    return readDayLoad({ ...readParams, date, requestIds, timezone })
      .then(({ data }) => {
        if (!signal.aborted) {
          setResponse({ data, isFailed: false, isLoading: false, requestKey })
        }
      })
      .catch(() => {
        if (!signal.aborted) {
          setResponse({
            data: null,
            isFailed: true,
            isLoading: false,
            requestKey,
          })
        }
      })
  }

  useEffect(() => {
    if (date) {
      const abortController = new AbortController()

      readLoad(abortController.signal)

      return () => {
        abortController.abort()

        setResponse(EMPTY_OBJECT)
      }
    }
  }, [requestKey, timezone])

  return getCalendarDayLoadState({ date, requestKey, response })
}
